export enum DsdFileStatus {
  DSD_ANALYZED = "DSD_ANALYZED",
  XBRL_ANALYZED = "XBRL_ANALYZED",
}

export interface DsdFileRaw {
  id: string;
  name: string;
  displayName: string | null;
  creator: string;
  revision: number;
  reportQuarter: string | null;
  reportYear: number | null;
  financialStatementType: string;
  companyCode: string | null;
  createdAt: string;
  updatedAt: string;
  status: DsdFileStatus;
  /** 직전 버전 워크북 id. 버전 스택을 링크드 리스트로 잇는다. 최초 업로드면 null. */
  prevWorkbookId: string | null;
  /** 화면에 보이는 버전 번호(V1, V2 …). 업로드 시 확정된 값이며 이후 바뀌지 않는다. */
  versionNo: number;
  /** 이 워크북을 만들어낸 업로드 DSD 의 파일 id. 파일 등록 도입 전 워크북은 null. */
  uploadedFileId: string | null;
}

export interface DsdFile extends DsdFileRaw {
  label: string;
}

/** NOT_TARGET: 셀 단위 분석 대상이 아니라 분석을 돌리지 않은 시트(본문 재무제표·일반사항·회계정책·추정 등의 목차).
 * ADJUSTING_ROLE: 분석은 끝났지만 겹친 주석목차를 재배정하는 중 — 이 사이 편집하면
 * 재배정이 편집을 덮거나 건너뛴다. RUNNING/PENDING 과 같은 방식으로 취급한다. */
export type TaskStatusValue =
  | "PENDING"
  | "RUNNING"
  | "COMPLETED"
  | "FAILED"
  | "NOT_TARGET"
  | "ADJUSTING_ROLE";

export interface TaskStatusItem {
  taskId: string | null;
  status: TaskStatusValue;
  tableId: string;
}

export interface SheetTaskStatusItem {
  sheetId: string;
  status: TaskStatusValue;
  /** false 면 일반사항·회계정책·추정 등의 목차·본문 재무제표 — 그 시트에서는 단일 표 오토태깅·불러오기를 잠근다.
   * status 와 별개다: 규칙 도입 전에 분석된 일반사항·회계정책·추정 등의 목차는 COMPLETED 여도 false. */
  taggingTarget: boolean;
}

export interface GetTaskStatusResponse {
  sheets: SheetTaskStatusItem[];
}

/**
 * `/dsd-editor` 첫 모드. 홈 STEP2 "이전 DSD 불러오기" 와 리뷰 화면이 함께 쓰는 계약이라
 * 두 화면 어느 쪽도 아닌 여기가 소유한다(경계 규칙: 두 화면 이상이 쓰는 것만 공용).
 */
export const DSD_EDITOR_MODE = {
  upload: "upload",
  existingReport: "existingReport",
} as const;

export type DsdEditorMode =
  (typeof DSD_EDITOR_MODE)[keyof typeof DSD_EDITOR_MODE];

/** 다른 화면이 `/dsd-editor` 로 보낼 때 실어 보내는 navigate state. */
export type DsdReviewLocationState = { mode?: DsdEditorMode } | null;
